import cn from 'classnames'
import IPath from 'interfaces/IPath'
import React, { FC, useCallback, useState } from 'react'

import Link from 'next/link'

import usePlausible from 'utils/hooks/usePlausible'
import { MenuItemLocation, PlausibleEvent } from 'enums/plausible'
import styles from './PageSelector.module.scss'

interface IPageSelectorProps {
  pages?: IPath[]
  selectedPage?: IPath
  referrer: string
  pageName: string
}
const PageSelector: FC<IPageSelectorProps> = ({ pages, selectedPage, referrer, pageName }) => {
  const [opened, setOpened] = useState(false)
  const toggle = useCallback(() => {
    setOpened((state) => !state)
  }, [setOpened])
  const setEvent = usePlausible()
  const onClick = useCallback((link: any) => {
    setEvent(PlausibleEvent.ClickedMenuItem, {
      name: link.title,
      url: link.link,
      referrer,
      location: MenuItemLocation.Content,
    })
  }, [])
  return (
    <div className={styles.pageSelector}>
      <div className={styles.pageSelector_mobile}>
        <div onClick={toggle} className={cn(styles.tab, styles.currentPage)}>
          <span>{selectedPage.title}</span>
          <img src="/images/util/arrow-down-black.svg" alt="arrow-down-black" />
        </div>
        {opened && (
          <div className={styles.options}>
            {pages
              .filter((page) => page.title !== selectedPage.title)
              .map((page) => {
                return (
                  <Link
                    className={styles.tab}
                    href={page.link}
                    onClick={() => onClick(page)}
                    id={`${pageName}-page_selector_mobile-${page.name}_page-link`}
                  >
                    {page.title}
                  </Link>
                )
              })}
          </div>
        )}
      </div>
      <div className={styles.pageSelector_desktop}>
        {pages.map((page) => {
          return (
            <Link
              href={page.link}
              className={cn(styles.tab, {
                [styles.currentPage]: page.title === selectedPage.title,
              })}
              onClick={() => onClick(page)}
              id={`${pageName}-page_selector_desktop-${page.name}_page-link`}
            >
              {page.title}
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default PageSelector
